import { isObservable, Observable, of } from 'rxjs';

export function wrapIntoObservable<T>(value: T | Observable<T>) {
  if (isObservable(value)) {
    return value;
  }

  return of(value);
}
